import { BaseMapper } from '../common/BaseMapper'

import { PdAPI, PdModel } from './type'

export class PdMapper extends BaseMapper {
  apiMapper = (pd: PdAPI): PdModel => ({
    id: pd.id,
    date: pd.date,
    os: {
      near: pd.os_near_pd,
      far: pd.os_pd,
    },
    od: {
      near: pd.od_near_pd,
      far: pd.od_pd,
    },
    state: pd.state,
  })

  public static defaultValue: PdModel = {
    id: 0,
    date: '',
    os: {
      near: 0,
      far: 0,
    },
    od: {
      near: 0,
      far: 0,
    },
    state: '',
  }
}
